import React from 'react';
import cl from "../css/mainStyle.module.css"
import {Link} from "react-router-dom";
import mainImg from "../images/hero.png"
import step1 from "../images/step-1.jpeg"
import step2 from "../images/step-2.jpg"
import step3 from "../images/step-3.jpg"
import step4 from "../images/step-4.jpeg"
import step5 from "../images/step-5.jpg"
import step6 from "../images/step-6.jpg"
import Education from "../components/Education/Education";
import Prepods from "../components/Prepods/Prepods";
import Reviews from "../components/Reviews/Reviews";

export const Home: React.FC = () => {
    return (
        <div className={cl.home}>
            <div className={`${cl.home__row} ${cl.home__row1} ${cl.bg1}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h1>Подготовка к ЕГЭ и другие образовательные программы в «Эмпириум»</h1>
                        <p className={cl.eruditHero__subtitle}>
                            Учебный центр «Эмпириум» – это современная образовательная среда, где ученики не просто «подтягивают» предметы, а учатся понимать, мыслить и достигать целей. Мы соединяем сильную академическую подготовку с развитием критического мышления, мотивации и уверенности в себе.
                        </p>
                        <a href="https://max.ru/u/f9LHodD0cOIs9p6PJRQtfZISoVAwHa37CvW1w92REzQ8aKo6Wf1dd4QY6UA" className={cl.home__btn}>
                            Записаться на занятие
                        </a>
                        <p className={cl.eruditForm__small}>
                            Нажимая кнопку, вы соглашаетесь с <Link to="/privacy">обработкой персональных данных</Link>.
                        </p>

                    </div>
                    <div className={`${cl.home__cell__block}`}>
                        <img src={mainImg} alt=""/>
                    </div>
                </div>
            </div>
            <div className={`${cl.home__row} ${cl.bg2}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>О центре «Эмпириум»</h2>
                        <p className={cl.home__blockText}>
                            «Эмпириум» – образовательный центр, где занятия проходят в комфортном формате: небольшие группы, живое общение с преподавателем и четкий фокус на экзаменационный результат. Мы фокусируемся на: преподавании академических предметов (для детей и подростков) школьной программы, дополнительном образовании (экономика, финансовая грамотность, MS Excel), а также обучении игре в шахматы детей (от 5 лет) и взрослых.
                        </p>
                        <div className={cl.homeCard__advantagesRow}>
                            <div className={cl.homeCard__advantages}>
                                <div className={cl.homeCard__title}>
                                    <h3>Небольшие группы</h3>
                                </div>
                                <div className={cl.homeCard__description}>
                                    <p>Преподаватель успевает уделить внимание каждому ученику, вовремя заметить сложности и помочь с их решением.</p>
                                </div>
                            </div>
                            <div className={cl.homeCard__advantages}>
                                <div className={cl.homeCard__title}>
                                    <h3>Живое общение</h3>
                                </div>
                                <div className={cl.homeCard__description}>
                                    <p>Преподаватель — не отстранённый лектор, а наставник. Ученик не боится задавать вопросы и активно участвует в занятии, поэтому материал действительно понимается и запоминается..</p>
                                </div>
                            </div>
                            <div className={cl.homeCard__advantages}>
                                <div className={cl.homeCard__title}>
                                    <h3>Фокус на результат</h3>
                                </div>
                                <div className={cl.homeCard__description}>
                                    <p>Мы выстраиваем занятия так, чтобы знания отражались в оценках и экзаменационных баллах. Регулярно отслеживаем прогресс и подсказываем, на что стоит обратить внимание.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Education/>
            <div className={`${cl.home__row} ${cl.bg3}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Как проходит обучение</h2>
                        <p className={cl.home__blockText}>
                            6 простых шагов - и ребенок уверенно идет к результату на ЕГЭ. Мы сопровождаем от первого теста до экзамена.
                        </p>
                        <div className={cl.eruditSteps}>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>01</span>
                                    <img className={cl.eruditStepTop__img} src={step1} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Диагностика знаний
                                </div>
                                <div className={cl.eruditStepText}>
                                    Определяем уровень знаний и составляем индивидуальный план обучения.
                                </div>
                            </div>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>02</span>
                                    <img className={cl.eruditStepTop__img} src={step2} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Подбор группы
                                </div>
                                <div className={cl.eruditStepText}>
                                    Подбираем оптимальную группу по предмету и уровню подготовки.
                                </div>
                            </div>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>03</span>
                                    <img className={cl.eruditStepTop__img} src={step3} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Обучение
                                </div>
                                <div className={cl.eruditStepText}>
                                    Занятия онлайн или офлайн по согласованному расписанию.
                                </div>
                            </div>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>04</span>
                                    <img className={cl.eruditStepTop__img} src={step4} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Тестирование
                                </div>
                                <div className={cl.eruditStepText}>
                                    Регулярно проводим пробные тестирования по материалам ЕГЭ.
                                </div>
                            </div>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>05</span>
                                    <img className={cl.eruditStepTop__img} src={step5} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Разбор ошибок
                                </div>
                                <div className={cl.eruditStepText}>
                                    Разбираем ошибки и закрываем пробелы, чтобы баллы росли.
                                </div>
                            </div>
                            <div className={cl.eruditStep}>
                                <div className={cl.eruditStepTop}>
                                    <span className={cl.eruditStepTop__badge}>06</span>
                                    <img className={cl.eruditStepTop__img} src={step6} alt=""/>
                                </div>
                                <div className={cl.eruditStepTitle}>
                                    Поддержка до экзамена
                                </div>
                                <div className={cl.eruditStepText}>
                                    Поддерживаем ученика вплоть до экзамена и мотивируем на успех.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Prepods/>
            <div className={`${cl.home__row} ${cl.bg3}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Расписание и важные новости</h2>
                        <div className={cl.eruditScheduleBox}>
                            <p>Актуальное расписание занятий и информация о ближайших событиях центра «Эмпириум» мы публикуем на отдельной странице.</p>
                            <Link to="/schedule" className={cl.eruditCard__btn}>Смотреть расписание</Link>
                        </div>
                    </div>
                </div>
            </div>
            <Reviews/>
            <div className={`${cl.home__row} ${cl.bg2}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Как нас найти</h2>
                        <p className={cl.home__blockText}>
                            Мы находимся в удобном месте недалеко от центра города. Рядом - остановки общественного транспорта и парковка.
                        </p>
                        <p className={cl.home__blockText}>
                            <b>Адрес:</b> г. Барнаул, пр. Комсомольский, д. 118, Офис 309
                        </p>
                        <p className={cl.home__blockText}>
                            <b>Режим работы:</b> Пн-ВС 08:30-21:00 по предварительной записи
                        </p>
                    </div>
                    <div className={`${cl.home__cell__block}`}>
                        <iframe className={cl.home__cell__blockMap} src="https://yandex.ru/map-widget/v1/?um=constructor%3A221571fbf42021d8d52699dd8b15f57da1ccc7200751ba3a8a0b383850b25c30&amp;source=constructor" width="600" height="500"></iframe>
                    </div>
                </div>
            </div>
            {/*<div className={`${cl.home__row} ${cl.bg3}`}>*/}
            {/*    <div className={`${cl.home__cell}`}>*/}
            {/*        <div className={`${cl.home__cell__block}`}>*/}
            {/*            <h2>Позвоните нам!</h2>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className={`${cl.home__row}  ${cl.footer} ${cl.bg4}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <p>Центр подготовки ООО «Эмпириум»</p>
                        <p>Телефон: <a href="tel:+79001635221">+7 (900) 163-52-21</a></p>
                        <p>ИНН: 2225238172</p>
                        <p>ОРГН: 1252200015484</p>
                        <p>Почта: eruditonline22@mail.ru</p>
                        <p>© 2026 ООО Эрудит Онлайн. Все права защищены.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};